import { PhoneNumberUtil, PhoneNumberType } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

const ACCEPTABLE_TYPES = new Set([
  PhoneNumberType.MOBILE,
  PhoneNumberType.FIXED_LINE_OR_MOBILE,
]);

/**
 * Google libphonenumber region check — number must belong to the given ISO region.
 */
export function isValidNumberForRegion(national, region) {
  const digits = String(national ?? "").replace(/\D/g, "");
  if (!digits || !region) return { valid: false };

  try {
    const parsed = phoneUtil.parseAndKeepRawInput(digits, region);
    if (!phoneUtil.isValidNumberForRegion(parsed, region)) {
      return { valid: false };
    }
    const type = phoneUtil.getNumberType(parsed);
    if (!ACCEPTABLE_TYPES.has(type)) {
      return { valid: false, type };
    }
    return { valid: true, type, parsed };
  } catch {
    return { valid: false };
  }
}

